import { render } from "./UserChoiceView.vue?vue&type=template&id=49ca7c2c"
import script from "./UserChoiceView.vue?vue&type=script&lang=js"
export * from "./UserChoiceView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__